"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobx_1 = require("mobx");

var react_router_1 = require("react-router");

var PantLogout_1 = require("../router/pantalles/PantLogout");

var PantLogin_1 = require("../router/pantalles/PantLogin");

var PantSessio_1 = require("../router/pantalles/PantSessio");

var PantHelp_1 = require("../router/pantalles/PantHelp");

var PantVersions_1 = require("../router/pantalles/PantVersions");

var PowerSettingsNew_1 = require("@material-ui/icons/PowerSettingsNew");

var AccountBox_1 = require("@material-ui/icons/AccountBox");

var format = require("string-format"); // const format = require('string-format');


var routeDefault = {
  nom: '',
  label: '',
  path: '/'
};
var routeSessio = {
  nom: 'Sessio',
  label: 'Sessio',
  path: '/sessio/:sescod',
  component: PantSessio_1.default
};
var routeHelp = {
  nom: 'Ajuda',
  label: 'Ajuda',
  path: '/help',
  component: PantHelp_1.default
};
var routeVerions = {
  nom: 'Versions',
  label: 'Versions',
  path: '/versions',
  component: PantVersions_1.default
};
var routeLogin = {
  nom: 'Login',
  label: 'LogIn',
  path: '/login',
  icon: AccountBox_1.default,
  component: PantLogin_1.default
};
var routeLogout = {
  nom: 'Logout',
  label: 'LogOut',
  path: '/logout',
  icon: PowerSettingsNew_1.default,
  component: PantLogout_1.default
};

var PantState =
/** @class */
function () {
  function PantState(appState) {
    var _this = this;

    this.navigatorTitleBase = '';
    this.navigatorTitle = '';
    this.pantalles = [routeDefault, routeLogin, routeLogout];
    this.pathActual = '/';
    this.urlBase = '/';
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.hasHeader = false;
    this.headerHeight = 64;
    this.hasToolbar = false;
    this.toolbarHeight = 40;

    this.pantalla = function (nom) {
      return _this.pantalles.find(function (pant) {
        return pant.nom === nom;
      }) || routeDefault;
    };

    this.navigatorTitleBase = appState.config.titolNavegador;
    this.setNavigatorTitle();
    this.setUrlBase(appState.config.urlBase);
    this.setPantalla(location.pathname);
  }

  PantState.prototype.setNavigatorTitle = function (title) {
    this.navigatorTitle = (title || '') + (title && this.navigatorTitleBase ? ' - ' : '') + (this.navigatorTitleBase || '');
  };

  PantState.prototype.setPantalles = function (pantalles) {
    var aPantalles = pantalles.slice(0);

    if (PantState.hiHaPrivateRoutes(aPantalles)) {
      if (!PantState.hiHaRoute(aPantalles, '/login')) {
        aPantalles.unshift(routeLogin);
      }

      if (!PantState.hiHaRoute(aPantalles, '/logout')) {
        aPantalles.unshift(routeLogout);
      }

      if (!PantState.hiHaRoute(aPantalles, '/sessio')) {
        aPantalles.unshift(routeSessio);
      }
    }

    if (!PantState.hiHaRoute(aPantalles, '/help')) {
      aPantalles.unshift(routeHelp);
    }

    if (!PantState.hiHaRoute(aPantalles, '/versions')) {
      aPantalles.unshift(routeVerions);
    }

    this.pantalles = aPantalles;
  };

  PantState.prototype.setHistory = function (history) {
    this.history = history;
  };

  PantState.prototype.setUrlBase = function (url) {
    this.urlBase = url;
  };

  PantState.prototype.setPantalla = function (path) {
    this.pathActual = PantState.replaceStart(path, this.urlBase + '/', '/');
  };

  Object.defineProperty(PantState.prototype, "pantallaActual", {
    get: function get() {
      var _this = this;

      return mobx_1.toJS(this.pantalles).find(function (pant) {
        return !!pant.path && !!react_router_1.matchPath(_this.pathActual, pant);
      }) || routeDefault;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PantState.prototype, "match", {
    get: function get() {
      return react_router_1.matchPath(this.pathActual, this.pantallaActual) || {
        params: {}
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PantState.prototype, "label", {
    get: function get() {
      return format(this.pantallaActual.label || this.pantallaActual.nom || '', this.match.params || {});
    },
    enumerable: true,
    configurable: true
  });

  PantState.hiHaPrivateRoutes = function (pantalles) {
    return pantalles.findIndex(function (pant) {
      return !!pant.isPrivate;
    }) >= 0;
  };

  PantState.hiHaRoute = function (pantalles, path) {
    return pantalles.findIndex(function (pant) {
      return pant.path === path;
    }) >= 0;
  };

  PantState.replaceStart = function (s, f, r) {
    return s.replace(new RegExp('^' + f, 'g'), r);
  }; // Salta cap a una altra pantalla afegint la nova url al history


  PantState.prototype.goPantalla = function (url) {
    if (this.history) {
      if (url.pathname) {
        this.history.push(url.pathname, url.state);
      } else {
        this.history.push(url);
      }
    }
  }; // Salta cap a una altra pantalla sobreescrivint la nova url al history


  PantState.prototype.replacePantalla = function (url) {
    if (this.history) {
      if (url.pathname) {
        this.history.replace(url.pathname, url.state);
      } else {
        this.history.replace(url);
      }
    }
  };

  PantState.prototype.goBack = function () {
    if (this.history) {
      this.history.goBack();
    }
  };

  PantState.prototype.updateWindowSize = function () {
    this.width = window.innerWidth;
    this.height = window.innerHeight;
  };

  PantState.prototype.setHasHeader = function () {
    this.hasHeader = true;
  };

  PantState.prototype.setHeaderHeight = function (pHeight) {
    this.headerHeight = pHeight;
  };

  Object.defineProperty(PantState.prototype, "marginHeader", {
    get: function get() {
      return this.hasHeader ? this.headerHeight : 0;
    },
    enumerable: true,
    configurable: true
  });

  PantState.prototype.setHasToolBar = function () {
    this.hasToolbar = true;
  };

  PantState.prototype.setToolbarHeight = function (pHeight) {
    this.toolbarHeight = pHeight;
  };

  Object.defineProperty(PantState.prototype, "marginToolbar", {
    get: function get() {
      return this.hasToolbar ? this.toolbarHeight : 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PantState.prototype, "marginHead", {
    get: function get() {
      return this.marginHeader + this.marginToolbar + 8;
    },
    enumerable: true,
    configurable: true
  });

  __decorate([mobx_1.observable], PantState.prototype, "navigatorTitleBase", void 0);

  __decorate([mobx_1.observable], PantState.prototype, "navigatorTitle", void 0);

  __decorate([mobx_1.observable], PantState.prototype, "pantalles", void 0);

  __decorate([mobx_1.observable], PantState.prototype, "pathActual", void 0);

  __decorate([mobx_1.observable], PantState.prototype, "urlBase", void 0);

  __decorate([mobx_1.observable], PantState.prototype, "history", void 0);

  __decorate([mobx_1.observable], PantState.prototype, "width", void 0);

  __decorate([mobx_1.observable], PantState.prototype, "height", void 0);

  __decorate([mobx_1.observable], PantState.prototype, "hasHeader", void 0);

  __decorate([mobx_1.observable], PantState.prototype, "headerHeight", void 0);

  __decorate([mobx_1.observable], PantState.prototype, "hasToolbar", void 0);

  __decorate([mobx_1.observable], PantState.prototype, "toolbarHeight", void 0);

  __decorate([mobx_1.action], PantState.prototype, "setNavigatorTitle", null);

  __decorate([mobx_1.action], PantState.prototype, "setPantalles", null);

  __decorate([mobx_1.action], PantState.prototype, "setHistory", null);

  __decorate([mobx_1.action], PantState.prototype, "setUrlBase", null);

  __decorate([mobx_1.action], PantState.prototype, "setPantalla", null);

  __decorate([mobx_1.computed], PantState.prototype, "pantallaActual", null);

  __decorate([mobx_1.computed], PantState.prototype, "match", null);

  __decorate([mobx_1.computed], PantState.prototype, "label", null);

  __decorate([mobx_1.action], PantState.prototype, "updateWindowSize", null);

  __decorate([mobx_1.action], PantState.prototype, "setHasHeader", null);

  __decorate([mobx_1.action], PantState.prototype, "setHeaderHeight", null);

  __decorate([mobx_1.computed], PantState.prototype, "marginHeader", null);

  __decorate([mobx_1.action], PantState.prototype, "setHasToolBar", null);

  __decorate([mobx_1.action], PantState.prototype, "setToolbarHeight", null);

  __decorate([mobx_1.computed], PantState.prototype, "marginToolbar", null);

  __decorate([mobx_1.computed], PantState.prototype, "marginHead", null);

  return PantState;
}();

exports.default = PantState;